/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import LogoutIcon from '../../Assets/icons/IconsJsx/LogoutIcon';
import CategoryIcon from '../../Assets/icons/IconsJsx/CategoryIcon.jsx';
import MonitorIcon from '../../Assets/icons/IconsJsx/MonitorIcon.jsx';
import PeopleIcon from '../../Assets/icons/IconsJsx/PeopleIcon.jsx';
import RateScheduleIcon from '../../Assets/icons/IconsJsx/RateScheduleIcon';
import LocationIcon from '../../Assets/icons/IconsJsx/LocationIcon';
import SettingIconV3 from '../../Assets/icons/IconsJsx/SettingIconV3.jsx';
import UserFill from '../../Assets/icons/IconsJsx/UserFill';
import DisplayOwner from '../../Assets/icons/IconsJsx/DisplayOwner.jsx';
import CampaignIcon from '../../Assets/icons/IconsJsx/CampaignIcon.jsx';
import MediaLibraryIcon from '../../Assets/icons/IconsJsx/MediaLibraryIcon.jsx';
import ArrowCircleLeft from '../../Assets/icons/IconsJsx/ArrowCircleLeft.jsx';
import FolderOutlineIcon from '../../Assets/icons/IconsJsx/FolderOutlineIcon.jsx';
import { Link } from 'react-router-dom';
import TPM from '../../Assets/images/tpmlogos.png';
import MenuItem from '../MenuItem';
import HeartIcon from '../../Assets/icons/IconsJsx/FavoriteIcon.jsx';
// import LayoutIcon from '../../Assets/images/responsive.png';

const Menu = ({ logout, userInfo, colors, permissionsList, widthHandler }) => {
  const variants = {
    open: { opacity: 1, x: 0 },
    closed: { opacity: 1, rotate: -90 },
  };

  const closedSize = '76.33%';
  const openedSize = '80%';

  const navigate = useNavigate();
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    if (!userInfo?.id) {
      navigate('/login');
    }
  }, [userInfo]);

  const links = [
    {
      normalTitle: 'MAIN',
      boldTitle: 'MENU',

      subMenus: [],
    },
    {
      // normalTitle: 'SETTINGS',
      // boldTitle: 'MENU',
      // subMenus: [
      //   {
      //     icon: [
      //       <SettingIconV3
      //         className={'w-full aspect-square'}
      //         fill={'#8F90A6'}
      //       />,
      //       <SettingIconV3
      //         className={'w-full aspect-square'}
      //         fill={`${colors?.mainColor}`}
      //       />,
      //     ],
      //     title: 'Settings',
      //     link: '/settings',
      //     show: permissionsList.includes('organization:view'),
      //     org: true,
      //   },
      // {
      //   icon: [
      //     <UserSquareIcon
      //       className={'w-full aspect-square'}
      //       fill={`${colors?.mainColor}`}
      //     />,
      //     <UserSquareIcon
      //       className={'w-full aspect-square'}
      //       fill={`${colors?.mainColor}`}
      //     />,
      //   ],
      //   title: 'User Manager',
      //   link: '/user-manager',
      //   show: permissionsList.includes('organization:view'),
      //   org: true,
      // },
      // {
      //   icon: [
      //     <DisplayOwner
      //       className={'w-full aspect-square'}
      //       fill={'#8F90A6'}
      //     />,
      //     <DisplayOwner
      //       className={'w-full aspect-square'}
      //       fill={`${colors?.mainColor}`}
      //     />,
      //   ],
      //   title: 'Profile',
      //   link: '/profile',
      //   show: permissionsList.includes('organization:view'),
      //   org: true,
      // },
      // ],
    },
  ];

  const getLinks = () => {
    switch (userInfo?.organization?.type) {
      case 'DSO':
        let DsoList = [
          {
            icon: [
              <CategoryIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <CategoryIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],
            title: 'Dashboard',
            link: '',
            show: permissionsList.includes('organization:view'),
            org: true,
          },
          {
            icon: [
              <RateScheduleIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <RateScheduleIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <RateScheduleIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Rate Schedules',
            link: '/rate-schedules',
            show: permissionsList.includes('organization:view'),
            org: userInfo?.organization.type === 'DSO' ? true : false,
          },
          // {
          //   icon: [
          //     <img
          //       src={LayoutIcon}
          //       className="w-full aspect-square"
          //       style={{ filter: 'grayscale(1) brightness(1)' }} // gray/disabled look
          //       alt="Layout"
          //     />,
          //     <img
          //       src={LayoutIcon}
          //       className="w-full aspect-square"
          //       style={{ filter: `drop-shadow(0 0 0.7px ${colors?.mainColor})` }} // colored look
          //       alt="Layout"
          //     />,
          //     <img
          //       src={LayoutIcon}
          //       className="w-full aspect-square"
          //       style={{ filter: `drop-shadow(0 0 0.7px ${colors?.mainColor})` }} // colored look

          //       alt="Layout"
          //     />,
          //   ],

          //   title: 'Layouts',
          //   link: '/layout-editor',
          //   show: permissionsList.includes('organization:view'),
          //   org: userInfo?.organization.type === 'DSO' ? true : false,
          // },
          {
            icon: [
              <UserFill
                className={'w-full aspect-square'}
                fill={'rgb(143,144,164)'}
              />,
              <UserFill
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              // <UserFill
              //   className={'w-full aspect-square'}
              //   fill={`${colors?.mainColor}`}
              // />,
            ],

            title: 'Users',
            link: '/users',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'DSO' && userInfo?.role_id === 1
                ? true
                : false,
          },
          {
            icon: [
              <MonitorIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <MonitorIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <MonitorIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Displays',
            link: '/displays',
            show: permissionsList.includes('organization:view'),
            org: userInfo?.organization.type === 'DSO' ? true : false,
          },
          {
            icon: [
              <LocationIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <LocationIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <LocationIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Locations',
            link: '/locations',
            show: permissionsList.includes('organization:view'),
            org: userInfo?.organization.type === 'DSO' ? true : false,
          },
          {
            icon: [
              <PeopleIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <PeopleIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <PeopleIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],
            title: 'Advertisers',
            link: '/advertiser',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'TPM'
                ? true
                : userInfo?.organization.type === 'DSO'
                  ? true
                  : false,
          },
          {
            icon: [
              <FolderOutlineIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <FolderOutlineIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <FolderOutlineIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],
            title: 'Campaigns Approval ',
            link: '/campaigns-approval',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'TPM'
                ? true
                : userInfo?.organization.type === 'DSO'
                  ? true
                  : false,
          },
          // {
          //   icon: [
          //     <HeartIcon className={'w-full aspect-square'} fill={'#8F90A6'} />,
          //     <HeartIcon
          //       className={'w-full aspect-square'}
          //       fill={`${colors?.mainColor}`}
          //     />,
          //     <HeartIcon
          //       className={'w-full aspect-square'}
          //       fill={`${colors?.mainColor}`}
          //     />,
          //   ],
          //   title: 'Favourites',
          //   link: '/favourites',
          //   show: permissionsList.includes('organization:view'),
          //   org:
          //     userInfo?.organization.type === 'TPM'
          //       ? true
          //       : userInfo?.organization.type === 'DSO'
          //       ? true
          //       : false,
          // },
          // {
          //   icon: [
          //     <PromotionIcon
          //       className={'w-full aspect-square'}
          //       fill={'#8F90A6'}
          //     />,
          //     <PromotionIcon
          //       className={'w-full aspect-square'}
          //       fill={`${colors?.mainColor}`}
          //     />,
          //   ],

          //   title: 'Promotions',
          //   link: '/promotions',
          //   show: permissionsList.includes('organization:view'),
          //   org: userInfo?.organization.type === 'DSO' ? true : false,
          // },
          // {
          //   icon: [
          //     <MediaRevenueIcone
          //       className={'w-full aspect-square'}
          //       fill={'#8F90A6'}
          //     />,
          //     <MediaRevenueIcone
          //       className={'w-full aspect-square'}
          //       fill={`${colors?.mainColor}`}
          //     />,
          //   ],

          //   title: 'Media Revenues',
          //   link: '/revenues',
          //   show: permissionsList.includes('organization:view'),
          //   org: userInfo?.organization.type === 'DSO' ? true : false,
          // },
          {
            icon: [
              <MediaLibraryIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <MediaLibraryIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Media Library',
            link: '/',
            show: permissionsList.includes('organization:view'),
            org: userInfo?.organization.type === 'ADV' ? true : false,
          },
          {
            icon: [
              <SettingIconV3
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <SettingIconV3
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Settings',
            link: '/settings',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'TPM'
                ? true
                : userInfo?.organization.type === 'DSO'
                  ? true
                  : false,
          },
          // {
          //   icon: [
          //     <ReportIcon
          //       className={'w-full aspect-square'}
          //       fill={'#8F90A6'}
          //     />,
          //     <ReportIcon
          //       className={'w-full aspect-square'}
          //       fill={`${colors?.mainColor}`}
          //     />,
          //     <ReportIcon
          //       className={'w-full aspect-square'}
          //       fill={`${colors?.mainColor}`}
          //     />,
          //   ],

          //   title: 'Reports',
          //   link: '/reports',
          //   show: permissionsList.includes('organization:view'),
          //   org:
          //     userInfo?.organization.type === 'TPM'
          //       ? true
          //       : userInfo?.organization.type === 'DSO'
          //       ? true
          //       : false,
          // },
        ];
        links[0].subMenus = DsoList;
        return links;
      case 'ADV':
        let advList = [
          {
            icon: [
              <CategoryIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <CategoryIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],
            title: 'Dashboard',
            link: '',
            show: permissionsList.includes('organization:view'),
            org: true,
          },
          {
            icon: [
              <MonitorIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <MonitorIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <MonitorIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Displays',
            link: '/advertisers-displays',
            show: permissionsList.includes('organization:view'),
            org: userInfo?.organization.type === 'ADV' ? true : false,
          },
          {
            icon: [
              <UserFill
                className={'w-full aspect-square'}
                fill={'rgb(143,144,164)'}
              />,
              <UserFill
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,

              <UserFill
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Users',
            link: '/users',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'ADV' && userInfo?.role_id === 1
                ? true
                : false,
          },
          {
            icon: [
              <CampaignIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <CampaignIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Campaigns',
            link: '/campaigns',
            show: permissionsList.includes('organization:view'),
            org: userInfo?.organization.type === 'ADV' ? true : false,
          },
          {
            icon: [
              <SettingIconV3
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <SettingIconV3
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Settings',
            link: '/settings',
            show: permissionsList.includes('organization:view'),
            org: true,
          },
        ];
        links[0].subMenus = advList;
        return links;
      case 'TPM':
        let listAdmin = [
          {
            icon: [
              <CategoryIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <CategoryIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],
            title: 'Dashboard',
            link: '',
            show: permissionsList.includes('organization:view'),
            org: true,
          },
          {
            icon: [
              <DisplayOwner
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <DisplayOwner
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Display Owners',
            link: '/admin-display-owner',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'TPM'
                ? true
                : userInfo?.organization.type === 'ADV'
                  ? true
                  : false,
          },
          {
            icon: [
              <PeopleIcon
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <PeopleIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
              <PeopleIcon
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],
            title: 'Advertisers',
            link: '/admin-advertisers',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'TPM'
                ? true
                : userInfo?.organization.type === 'DSO'
                  ? true
                  : false,
          },

          {
            icon: [
              <SettingIconV3
                className={'w-full aspect-square'}
                fill={'#8F90A6'}
              />,
              <SettingIconV3
                className={'w-full aspect-square'}
                fill={`${colors?.mainColor}`}
              />,
            ],

            title: 'Settings',
            link: '/settings',
            show: permissionsList.includes('organization:view'),
            org:
              userInfo?.organization.type === 'TPM'
                ? true
                : userInfo?.organization.type === 'DSO'
                  ? true
                  : false,
          },
        ];
        links[0].subMenus = listAdmin;
        return links;
    }
  };
  return (
    <menu
      style={{
        background: 'rgb(246, 246, 246, 1)',

        border: `1px solid ${colors.backGroundColor}`,
        backdropFilter: 'blur(50px)',
        width: `${isClosed ? '6.822vw' : '15.1vw'}`,
      }}
      className="h-[81.2vh] fixed w-[15.1vw] flex justify-center items-center shadow-nav rounded-20 mt-4 "
    >
      <div className="h-full w-full relative flex justify-center items-end pb-[30px]">
        <motion.div
          animate={isClosed ? 'closed' : 'open'}
          variants={{
            open: {
              rotate: 0,
            },
            closed: {
              rotate: 180,
            },
          }}
          onClick={() => {
            widthHandler(isClosed ? '15.1vw' : '6.822vw');
            setIsClosed(!isClosed);
          }}
          style={{ color: colors?.mainColor }}
          className="w-10 aspect-square p-1 absolute right-0 top-0  rounded-full  flex-end shadow-md m-2 cursor-pointer"
        >
          {' '}
          <ArrowCircleLeft
            style={{
              background: `${colors.secondryColor}`,
            }}
            fill={`${colors.secondryColor}`}
            className="object-cover h-full aspect-square"
          />
        </motion.div>
        <div
          style={{
            width: `${isClosed ? '76.33%' : '69%'}`,
          }}
          className="h-[91%] flex flex-col justify-between  relative"
        >
          <div
            style={{ color: colors?.mainColor }}
            className="w-[100%] h-auto self-center flex flex-col gap-[2.87vh] items-start "
          >
            <div
              style={{
                color: colors?.mainColor,
                fontSize: `${isClosed ? '13px' : ' 22px'}`,
              }}
              className="global-font-bold font-bold flex justify-center items-end "
            >
              <motion.h3
                variants={variants}
                animate={isClosed ? 'closed' : 'open'}
                className="w-auto"
              >
                WELCOME TO <br />
                <span
                  className="font-light  global-font-light "
                  style={{
                    color: colors.thirdFontcolor,
                    fontSize: `${isClosed ? '10px' : ' 16px'}`,
                  }}
                >
                  YOUR DASHBOARD
                </span>
              </motion.h3>
            </div>
          </div>

          <div className="h-[65.4%] flex flex-col gap-[3.8vh]">
            <div className="h-[67.8%] w-full flex flex-col gap-[6.1%]">
              <h2
                style={{
                  color: colors.thirdFontcolor,
                  fontSize: `${isClosed ? '14px' : '16px'}`,
                }}
                className="text-base font-light font-Montserrat"
              >
                {getLinks() ? getLinks()[0].normalTitle : ''}
                <span className="font-bold">
                  {getLinks() ? getLinks()[0].boldTitle : ''}
                </span>
              </h2>
              <div className="h-auto gap-[0.9vh] w-full flex flex-col justify-between  ">
                {!isClosed && (
                  <div className="w-[9.5%] h-0 border-t-2 border-[#555770]" />
                )}

                {getLinks()
                  ? getLinks()[0]
                    ?.subMenus?.filter((item) => item.show)
                    .map((item, idx) => {
                      return (
                        item.org && (
                          <Link
                            className="flex justify-center items-center"
                            key={idx}
                            to={item.link}
                          >
                            <MenuItem
                              isClosed={isClosed}
                              text={item?.title}
                              icon={item?.icon}
                              locationPath={item.link}
                            />
                          </Link>
                        )
                      );
                    })
                  : ''}
              </div>
            </div>

            {/* <div className="h-[33.2%] flex flex-col gap-[10.8%]">
              <h2
                style={{
                  color: colors.thirdFontcolor,
                  fontSize: `${isClosed ? '14px' : '16px'}`,
                }}
                className="text-base font-light font-Montserrat"
              >
                {links[1].normalTitle}
                {!isClosed && (
                  <span className="font-bold">{links[1].boldTitle}</span>
                )}
              </h2>

              <div className="h-auto gap-[0.92vh] w-full flex flex-col  justify-center ">
                {!isClosed && (
                  <div className="w-[9.5%] h-0 border-t-2 border-[#555770]" />
                )}
                {links[1]?.subMenus
                  ?.filter((item) => item.show)
                  .map((item, idx) => {
                    return (
                      <Link
                        className="flex justify-center items-center"
                        key={idx}
                        to={item.link}
                      >
                        <MenuItem
                          isClosed={isClosed}
                          text={item?.title}
                          icon={item?.icon}
                          locationPath={item.link}
                        />
                      </Link>
                    );
                  })}
              </div>
            </div> */}
          </div>

          <div
            style={{ color: '#D92C20', marginTop: 35 }}
            className="h-[10.6%] w-[100%] self-center flex flex-col  justify-between"
          >
            <div
              onClick={async () => {
                await logout(userInfo?.id);
                navigate('/login');
              }}
              className={`h-[28.2%] w-full flex  ${isClosed ? 'justify-center' : 'justify-between'
                } items-start cursor-pointer`}
            >
              {!isClosed && (
                <div className="font-Montserrat font-normal text-base">
                  Logout
                </div>
              )}

              <LogoutIcon
                fill={'rgb(217, 44, 32)'}
                className={'h-full aspect-square'}
              />
            </div>
            {/* <div className="flex flex-col items-start gap-0"> */}
            {/* <p
                style={{
                  fontSize: `${isClosed ? '10px' : '14px'}`,
                }}
                className="  text-gray-400 pt-3"
              >
                Powered By
              </p> */}
            {/* <img
                className="w-[100%] object-cover my-3"
                src={TPM}
                alt=""
              ></img>
            </div> */}
          </div>
          <br />
        </div>
      </div>
    </menu>
  );
};

const mapState = (state) => ({
  systemToast: state.systemToast,
  userInfo: state.user.data,

  permissionsList: state.user.permissions,
});
const mapDispatch = (dispatch) => ({
  logout: (id) => dispatch.user.logout(id),
});

export default connect(mapState, mapDispatch)(React.memo(Menu));
